import { clearAuthHeader } from "./axios";

/**
 * 解析时间
 * @param t
 * @returns {string}
 * @constructor
 */
export function ParseTime(t) {
  let pt = new Date(t);
  return `${pt.getFullYear()}-${pt.getMonth() +
    1}-${pt.getDate()} ${pt.getHours()}:${pt.getMinutes()}:${pt.getSeconds()}`;
}

export const ParseTimeFilterMixin = {
  filters: {
    parseTime: function(v) {
      return ParseTime(v);
    }
  }
};

export const ElTableFormatterMixin = {
  methods: {
    timeFormatter(row, column, cellValue, index) { /*eslint-disable-line*/
      return ParseTime(cellValue);
    },
    emptyTextFormatter(row, column, cellValue, index) {/*eslint-disable-line*/
      return cellValue ? cellValue : "-";
    }
  }
};

export const LogoutMixin = {
  methods: {
    logout() {
      window.localStorage.removeItem("token");
      clearAuthHeader();
      this.$router.push({ name: "login" });
    }
  }
};

export const OopsErrorELMessage = {
  methods: {
    oopsError(message = "") {
      this.$message({
        type: "error",
        message: message ? message : "Oops!",
        showClose: true,
        duration: 5000
      });
    }
  }
};

// Tag对象转为Tag文本列表Mixin
export const TagsStrArrayMixin = {
  methods: {
    tagsToStrArray(tags) {
      return tags.map(tag => tag.name);
    }
  }
};

const defaultPaging = {
  total: 0,
  total_page: 0,
  prev: false,
  next: false
};

// RouteQueryPageMixin是实现了$route.query.page参数的mixin
export const RouteQueryPageMixin = {
  data() {
    return {
      currentPage: 1,
      // 观察page更新回调方法
      onPageWatchUpdate: () => {}
    };
  },
  created() {
    // 初始化配置当前page
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
  },
  computed: {
    queryPage() {
      return this.$route.query.page ? this.$route.query.page : "1";
    }
  },
  watch: {
    queryPage(page) {
      this.currentPage = parseInt(page);
      this.onPageWatchUpdate();
    }
  },
  methods: {
    handlePaginatorPageChange(v) {
      this.currentPage = v;
      let query = { ...this.$route.query };
      query["page"] = v;
      this.$router.push({ path: this.$route.path, query });
    }
  }
};

// RouteQueryTagMixin是实现了$route.query.tag参数的mixin
export const RouteQueryTagMixin = {
  data() {
    return {
      // Tag更新时的回调方法
      onTagWatchUpdate: () => {}
    };
  },
  computed: {
    queryTag() {
      return this.$route.query.tag ? this.$route.query.tag : "";
    },
    hasQueryTag() {
      return this.queryTag !== "";
    }
  },
  watch: {
    queryTag() {
      this.onTagWatchUpdate();
    }
  },
  methods: {
    clearQueryTag() {
      let query = { ...this.$route.query };
      delete query["tag"];
      query["page"] = "1";
      this.$router.push({ path: this.$route.path, query });
    }
  }
};

export const ReposListPagingMixin = {
  mixins: [OopsErrorELMessage],
  data() {
    return {
      repos: [],
      paging: defaultPaging,
      pageSize: 15
    };
  },
  methods: {
    getReposList(target, params = {}) {
      this.$http
        .get(target, { params })
        .then(resp => {
          if (resp.data.repos) {
            this.repos = resp.data.repos;
            this.paging = resp.data.paging;
          } else {
            this.repos = resp.data;
            this.paging = defaultPaging;
          }
        })
        .catch(() => this.oopsError());
    }
  }
};

export const ReposMixin = {
  mixins: [
    OopsErrorELMessage,
    ReposListPagingMixin,
    RouteQueryTagMixin,
    RouteQueryPageMixin
  ],
  data() {
    return {
      // mixins
      onTagWatchUpdate: this.listRepos,
      onPageWatchUpdate: this.listRepos
    };
  },
  methods: {
    listRepos(draft = false) {
      let target = "/api/v1/repos";
      if (draft) {
        target = target + "/draft";
      }
      let params = { page_size: this.pageSize, ...this.$route.query };
      this.getReposList(target, params);
    },
    deleteRepo(repo) {
      this.$http
        .delete(`/api/v1/repos/${repo.id}`)
        .then(() => {
          let idx = this.repos.findIndex(x => x.id === repo.id);
          this.repos.splice(idx, 1);
          this.$eventbus.$emit("ResetDeleteIconButton");
        })
        .catch(() => this.oopsError());
    }
  }
};

export const RepoMixin = {
  mixin: [OopsErrorELMessage],
  data() {
    return {
      repo: {
        created_at: "",
        updated_at: "",
        published_at: null,
        title: "",
        version: "",
        readme: "",
        script: "",
        author: { id: 0, screen_name: "" },
        tags: [],
        archives: [],
        node: { id: 0 }
      }
    };
  },
  created() {
    this.$http
      .get(this.repoURI)
      .then(resp => {
        this.repo = resp.data;
      })
      .catch(() => this.oopsError());
  },
  computed: {
    repoID() {
      return this.$route.params.repo_id;
    },
    repoURI() {
      return `/api/v1/repos/${this.repoID}`;
    },
    published: {
      get: function() {
        return this.repo.published_at !== null;
      },
      set: function() {
        this.publishRepoSwitch();
      }
    }
  },
  methods: {
    routeToPreview() {
      this.$router.push({
        name: "repo_preview",
        params: { repo_id: this.repoID }
      });
    }
  }
};

export const ReleasesMixin = {
  mixins: [OopsErrorELMessage, RouteQueryPageMixin, RouteQueryTagMixin],
  data() {
    return {
      releases: [],
      paging: defaultPaging,
      pageSize: 15,

      // mixins
      onTagWatchUpdate: this.listReleases,
      onPageWatchUpdate: this.listReleases
    };
  },
  methods: {
    listReleases(draft = false) {
      let target = "/api/v1/releases";
      if (draft) {
        target = target + "/draft";
      }
      this.$http
        .get(target, {
          params: {
            page_size: this.pageSize,
            ...this.$route.query
          }
        })
        .then(resp => {
          if (draft) {
            this.releases = resp.data;
            this.paging = defaultPaging;
          } else {
            this.releases = resp.data.releases;
            this.paging = resp.data.paging;
          }
        })
        .catch(() => this.oopsError());
    },
    deleteRelease(release) {
      this.$http
        .delete(`/api/v1/releases/${release.id}`)
        .then(() => {
          let idx = this.releases.findIndex(x => x.id === release.id);
          this.releases.splice(idx, 1);
          this.$eventbus.$emit("ResetDeleteIconButton");
        })
        .catch(() => this.oopsError());
    }
  }
};

export const ReleaseMixin = {
  data() {
    return {
      release: {
        created_at: "",
        updated_at: "",
        published_at: null,
        title: "",
        readme: "",
        author: { id: 0, screen_name: "" },
        tags: [],
        repos: []
      }
    };
  },
  created() {
    this.getRelease();
  },
  computed: {
    releaseID() {
      return this.$route.params.release_id;
    },
    releaseURI() {
      return `/api/v1/releases/${this.releaseID}`;
    },
    published: {
      get: function() {
        return this.release.published_at !== null;
      },
      set: function() {
        this.publishReleaseSwitch();
      }
    }
  },
  methods: {
    getRelease() {
      this.$http
        .get(`/api/v1/releases/${this.releaseID}`)
        .then(resp => (this.release = resp.data))
        .catch(err => this.oopsError(err));
    }
  }
};

// ClaimRolePermissionMixin实现通过$store获取claim.role
export const ClaimRolePermissionMixin = {
  computed: {
    /**
     * 获取$store中的claim
     * @returns {Object}
     */
    claim() {
      return this.$store.getters.claim;
    },

    /**
     * 获取$store中的claim.role
     * @returns {string}
     */
    role() {
      return this.claim.role;
    },

    /**
     * 判断role为super的快捷方式
     * @returns {*|boolean}
     */
    isSuper() {
      return this.hasPermRoles(["super"]);
    },

    /**
     * 判断role为super|admin的快捷方式
     * @returns {*|boolean}
     */
    isSuperAdmin() {
      return this.hasPermRoles(["admin", "super"]);
    }
  },
  methods: {
    /**
     * 判断当前claim.role是否具有权限
     * @param roles 具有权限的role
     * @returns {boolean}
     */
    hasPermRoles(roles = []) {
      for (let role of roles) {
        if (this.role === role) {
          return true;
        }
      }
      return false;
    }
  }
};

// 判断资源权限Mixin
export const ResourceOwnerMixin = {
  mixins: [ClaimRolePermissionMixin],
  computed: {
    claimID() {
      return this.claim.id;
    }
  },
  methods: {
    isSameOwner(resourceOwnerID) {
      return this.claimID === resourceOwnerID;
    },
    isSameOwnerOrSuper(resourceOwnerID) {
      return this.isSuper || this.isSameOwner(resourceOwnerID);
    }
  }
};

export const RoleCNMixin = {
  methods: {
    roleLabel(role) {
      switch (role) {
        case "super":
          return "超级管理员";
        case "admin":
          return "开发管理员";
        case "staff":
          return "内部员工";
        default:
          throw new Error("未定义权限");
      }
    },
    roleCNFormatter(row, column, cellValue, index) { /*eslint-disable-line*/
      return this.roleLabel(cellValue);
    }
  }
};

// UserFormMixin实现用户表单校验的mixin
export const UserFormMixin = {
  data() {
    let nameLenRule = {
      min: 5,
      max: 10,
      message: "字符长度限制为5-10",
      trigger: "blur"
    };
    let passLenRule = {
      min: 6,
      max: 16,
      message: "密码最小长度限制为6-16",
      trigger: "blur"
    };
    return {
      rules: {
        username: [
          { required: true, message: "请输入登录名", trigger: "blur" },
          nameLenRule
        ],
        screen_name: [
          { required: true, message: "请输入显示名", trigger: "blur" },
          nameLenRule
        ],
        oPass: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          passLenRule
        ],
        pass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          passLenRule
        ],
        checkPass: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          passLenRule,
          { validator: this.validatePass2, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    validatePass2(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.form.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    }
  }
};
